import { spacings } from "../../assets/themes";
import { Block, Container } from "../../components";
import { useBreakpoints } from "../../modules/hooks";

const CustomContainer = ({ children }) => (
  <Block marginX={{ xs: spacings.sm, md: "0px" }}>{children}</Block>
);
export default CustomContainer;
